import { render } from "./EmptyQuery.vue?vue&type=template&id=9150432a&scoped=true&ts=true"
import script from "./EmptyQuery.vue?vue&type=script&lang=ts"
export * from "./EmptyQuery.vue?vue&type=script&lang=ts"

import "./EmptyQuery.vue?vue&type=style&index=0&id=9150432a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9150432a"]])

export default __exports__